// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { FaBars, FaSearch, FaUser } from "react-icons/fa";
// import simplifyingLogo from "../../images/simplifyinglogo.png";
// import { useNavigate } from "react-router-dom";
// import image46 from "../../images/refer-icon.svg";
// import { FaPhone } from "react-icons/fa";
// const Mobile = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [academyOpen, setAcademyOpen] = useState(false);
//   const [assessmentOpen, setAssessmentOpen] = useState(false);
//   const [clubsOpen, setClubsOpen] = useState(false);
//   const [communityOpen, setCommunityOpen] = useState(false);
//   const [searchOpen, setSearchOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");

//   const closeAllNav = () => {
//     setMenuOpen(false);
//     setAcademyOpen(false);
//     setAssessmentOpen(false);
//     setClubsOpen(false);
//     setCommunityOpen(false);
//     setSearchOpen(false);
//     setSearchQuery("");
//   };

//   const navigate= useNavigate()

//   return (
//     <nav className="bg-blue-600 p-4  shadow-md  w-full z-50" style={{position:"sticky",top:0}}>
//       <div className="flex items-center justify-between">
//         {/* Logo */}
//         <div className="flex items-center">
//           <Link to="/">
//             <img src={simplifyingLogo} alt="simplifying skills" className="h-10 w-auto mr-3" />
//           </Link>
//         </div>


//         {/* Search, Menu & Login Icons */}
//         <div className="flex items-center space-x-4">
//           {/* <button className="text-white text-lg" onClick={() => setSearchOpen(!searchOpen)}>
//             <FaSearch />
//           </button> */}
//            <Link
//            to="/contact"
//             className="text-white bg-blue-900 sm:hidden  px-2 py-2 rounded-lg hover:bg-blue-950 flex items-center"
//             target="_blank"
//           >
//             <FaPhone className=""/>
//           </Link>
//           <a
//             href="https://skillsphere.simplifyingskills.com/login"
//             className="text-white bg-blue-900 px-3 py-1 rounded-md hover:bg-blue-950 flex items-center"
//             target="_blank" style={{fontFamily: "Montserrat" }}
//           >
//             <FaUser className="mr-2" style={{fontFamily: "Montserrat" }}/> Login
//           </a>
//           <button className="text-white text-2xl" onClick={() => setMenuOpen(!menuOpen)}>
//             <FaBars />
//           </button>
//         </div>
//       </div>

//       {/* Search Bar */}
//       {searchOpen && (
//         <div className="mt-2 flex">
//           <input
//             type="text"
//             placeholder="Search..."
//             className="w-full p-2 rounded-l-md text-gray-700"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//           <button className="bg-white text-blue-600 px-4 py-2 rounded-r-md">
//             <FaSearch />
//           </button>
//         </div>
//       )}

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="bg-blue-700 py-2 mt-2 rounded-lg">
//           <div className="px-4">
//             <ul className="bg-blue-800">
//               <li className="px-4 py-2 text-white hover:bg-gray-200 hover:text-black cursor-pointer" >
//                 <Link to="/nextgeni" onClick={closeAllNav} style={{fontFamily: "Montserrat" }}>
//                   Nextgen Innovators
//                 </Link>
//               </li>
//               <li className="px-4 py-2 text-white hover:bg-gray-200 hover:text-black cursor-pointer">
//                 <Link to="/nextgenj" onClick={closeAllNav} style={{fontFamily: "Montserrat" }}>
//                   Nextgen Juniors
//                 </Link>
//               </li>
//               <li className="px-4 py-2 text-white hover:bg-gray-200 hover:text-black cursor-pointer">
//                 <Link to="/skillsphere-assessment" onClick={closeAllNav} style={{fontFamily: "Montserrat" }}>
//                   Skillsphere Assessment
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Mobile;

import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import Lottie from 'lottie-react';
import burgerAnimation from '../../assets/menuV2.json';
import { ExpandMore } from '@mui/icons-material';

// Import Lottie icons for each section
const productsIcon = 'https://dbqa318yoj3nn.cloudfront.net/productsIcon.png';
const Packagesicon = 'https://dbqa318yoj3nn.cloudfront.net/Packages.png';
const coursesIcon = 'https://dbqa318yoj3nn.cloudfront.net/Courses.png';
const clubIcon = 'https://dbqa318yoj3nn.cloudfront.net/Clubsicons.png';
const communityIcon = 'https://dbqa318yoj3nn.cloudfront.net/Community.png';

const menu = [
  {
    title: 'Products',
    icon: productsIcon,
    child: [
      { label: 'Class 1-5', desc: 'Learn Smart with Theme-Based Learning', route: '/nextgenj' },
      { label: 'Class 6-10', desc: 'Learn Smart with Skill-Based Learning', route: '/nextgeni' },
      { label: 'University', desc: 'From Campus To Corporate', route: '/campus' },
      { label: 'Corporate', desc: 'Where Placement Meets Purpose', route: '/nextgenPlacement' },
      { label: 'Assessment Center', desc: 'Skillsphere Assessment', route: '/' },
    ]
  },
  {
    title: 'Club',
    icon: clubIcon,
    child: [
      { label: 'Entrepreneurship League', route: '/entrepreneurship' },
      { label: 'Engineering Explorers', route: '/engineeringexplorers' },
      { label: 'Medical Mavericks', route: '/medicalmavericks' },
      { label: 'Artistic Visionaries', route: '/artisticvisionaries' },
      { label: 'Business Trailblazers', route: '/businesstrailbazars' },
      { label: 'Administrative Achievers', route: '/administrativeAchievers' },
      // { label: 'Law, Civics & Policy Club', },
      // { label: 'Law, Civics & Policy Club', },
    ]
  },
  {
    title: 'Community',
    icon: communityIcon,
    child: [
      { label: 'Blogs', route: '/blog' },
    ],
  },
  {
    title: 'Packages',
    icon: Packagesicon,
    route: '/Packages'
  },
];

const Header = () => {
  const navigate = useNavigate();
  const burgerRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);

  const toggleBurger = () => {
    if (!burgerRef.current) return;
    burgerRef.current.setSpeed(1.5);
    if (!isOpen) {
      burgerRef.current.playSegments([0, 45], true);
    } else {
      burgerRef.current.playSegments([45, 0], true);
    }
    setIsOpen(!isOpen);
  };

  const toggleExpand = (index) => {
    setExpandedItem(expandedItem === index ? null : index);
  };

  return (
    <>
      {/* Top Header */}
      <div style={{
        width: '100%',
        padding: '12px 24px',
        backgroundColor: '#f5f7fc',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {/* Burger Icon */}
          <div style={{ cursor: 'pointer' }} onClick={toggleBurger}>
            <Lottie
              lottieRef={burgerRef}
              animationData={burgerAnimation}
              loop={false}
              autoplay={false}
              style={{ width: '32px', height: '32px' }}
            />
          </div>

          {/* Logo */}
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/home')}>
            <img src="https://dbqa318yoj3nn.cloudfront.net/SIMPLIFYING%20SKILLS%201.png" alt="Simplifying Skills" style={{ height: '25px' }} />
          </div>
        </div>

        {/* Contact Button */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={() => navigate('/contact')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              background: 'linear-gradient(to bottom right, #3479FFCF, #468eff)',
              border: 'none',
              borderRadius: '30px',
              padding: '8px 15px',
              color: '#fff',
              fontWeight: 500,
              fontSize: '16px',
              fontFamily: 'Segoe UI, sans-serif',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              outline: 'none',
            }}
          >
            <PhoneRoundedIcon style={{ color: 'white', fontSize: 22 }} />
            Contact
          </button>
        </div>
      </div>

      {/* Drawer */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100%',
        width: '300px',
        backgroundColor: '#f5f7fc',
        boxShadow: '2px 0 20px rgba(0,0,0,0.1)',
        padding: '24px 16px',
        transition: 'transform 0.3s ease-in-out',
        transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
        zIndex: 1000,
        borderTopRightRadius: '24px',
        borderBottomRightRadius: '24px',
      }}>
        {/* Drawer Header: Close button + Logo aligned */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '32px',
        }}>
          <div style={{ cursor: 'pointer' }} onClick={toggleBurger}>
            <Lottie
              lottieRef={burgerRef}
              animationData={burgerAnimation}
              loop={false}
              autoplay={false}
              style={{ width: '32px', height: '32px' }}
            />
          </div>
          <div style={{ cursor: 'pointer' }} onClick={() => {
            toggleBurger();
            navigate('/');
          }}>
            <img src="https://dbqa318yoj3nn.cloudfront.net/SIMPLIFYING%20SKILLS%201.png" alt="Simplifying Skills" style={{ height: '30px' }} />
          </div>
        </div>

        {menu.map((item, idx) => (
          <div key={idx}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 0',
                borderBottom: '1px solid #e0e0e0',
                fontSize: '17px',
                fontWeight: 500,
                cursor: 'pointer',
              }}
              onClick={() => {
                if (item.child) {
                  toggleExpand(idx);
                } else {
                  toggleBurger();
                  navigate(item.route);
                }
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {item.icon && (
                  <img src={item.icon} alt={item.title} style={{ width: 30, height: 30 }} />
                )}
                {item.title}
              </div>
              {item.child && <ExpandMore style={{ fontSize: 20 }} />}
            </div>

            {expandedItem === idx && item.child && (
              <div style={{ paddingLeft: '40px', paddingTop: '8px' }}>
                {item.child.map((child, cIdx) => (
                  <div
                    key={cIdx}
                    onClick={() => {
                      toggleBurger();
                      navigate(child.route);
                    }}
                    style={{
                      marginBottom: '12px',
                      cursor: 'pointer',
                      color: '#444',
                    }}
                  >
                    <div style={{ fontWeight: '600' }}>{child.label}</div>
                    <div style={{ fontSize: '12px', color: '#888' }}>{child.desc}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          onClick={toggleBurger}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            zIndex: 999,
          }}
        />
      )}
    </>
  );
};

export default Header;
